export enum RequestContextType {
	Shop = "shop",
	Online = "online",
	Wallet = "wallet",
	Default = "default",
}
